const { getSize, getMargin, getPadding, getBorderWidth } = require('../../modules/element-state');

/**
 * Placeholder
 * @class
 */
class Placeholder {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      tagName  : 'span',
      className: 'placeholder',
    }
  }

  /**
   * @instance
   * @param el {HTMLElement} element
   * @param opts {object} options
   */
  constructor(el, opts = {}) {
    const { tagName, className } = _.defaultsDeep(opts, Placeholder.defOpts);

    if(document.createElement('input').placeholder !== undefined) return;

    const placeholder = el.getAttribute('placeholder');

    if(!placeholder) return;

    this.el   = el;
    this.phEl = document.createElement(tagName);

    const size        = getSize(el);
    const margin      = getMargin(el);
    const padding     = getPadding(el);
    const borderWidth = getBorderWidth(el);
    const style = getComputedStyle(el, null);

    this.phEl.setAttribute('class', className);
    this.phEl.innerHTML = placeholder;
    this.phEl.style.display       = 'block';
    this.phEl.style.width         = `${size.w}px`;
    this.phEl.style.height        = `${size.h}px`;
    this.phEl.style.marginTop     = `${margin.top}px`
    this.phEl.style.marginRight   = `${margin.right}px`
    this.phEl.style.marginBottom  = `${margin.bottom}px`
    this.phEl.style.marginLeft    = `${margin.left}px`
    this.phEl.style.paddingTop    = `${padding.top + borderWidth.top}px`
    this.phEl.style.paddingRight  = `${padding.right + borderWidth.right}px`
    this.phEl.style.paddingBottom = `${padding.bottom + borderWidth.bottom}px`
    this.phEl.style.paddingLeft   = `${padding.left + borderWidth.left}px`
    this.phEl.style.position      = 'absolute';
    this.phEl.style.top           = '0';
    this.phEl.style.left          = '0';
    this.phEl.style.lineHeight    = `${size.h}px`;
    this.phEl.style.textAlign     = style.textAlign;
    this.el.parentNode.insertBefore(this.phEl, el.nextSibling);

    this.phEl.addEventListener('mousedown', this.onMousedowned.bind(this), false);
    el.addEventListener('focus', this.onFoucsed.bind(this), false);
    el.addEventListener('blur', this.onBlured.bind(this), false);
  }

  /**
   * @instance
   * @private
   */
  onMousedowned() {
    this.el.focus();
  }

  /**
   * @instance
   * @private
   */
  onFoucsed() {
    this.phEl.style.display = 'none';
  }

  /**
   * @instance
   * @private
   */
  onBlured() {
    if(this.el.value === '') {
      this.phEl.style.display = 'block';
    }
  }

}

/**
 * class exports
 */
module.exports = Placeholder;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/form/placeholder.js
 **/